import React, {useEffect, useState} from 'react';
import {useNavigate, useOutletContext} from 'react-router-dom';
import {useInfiniteScroll} from "../../../hooks/useInfiniteScroll";
import {getMemberPayUseList} from "../../../api/transaction/payApi";
import {setComma, splitDateTime} from "../../../utils/format";
import InfiniteScrollSentinel from "../../../components/common/InfiniteScrollSentinel";
import {EmptyState} from "../../../components/common/EmptyStateProps";
import {OutletContextType} from "../../../types/common/oulet.comtext.types";


export default function UseListPage() {
    const navigate = useNavigate();
    const {searchTypes, setTotalSize, searchTrigger} = useOutletContext<OutletContextType>();
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const {
        accumulatedRows,
        showMoreButton,
        nextPage,
        appendPageData,
        resetPageData,
    } = useInfiniteScroll();

    const handleSearch = async () => {
        try {
            setLoading(true);
            const response = await getMemberPayUseList({
                ...searchTypes,
                page: 1
            });
            if (response?.data?.data) {
                resetPageData(response.data.data, searchTypes.size | 5);
                setTotalSize(response.data.data.totalSize || 0);
            }
        } catch (err) {
            console.error('사용 내역 에러:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleLoadMore = async () => {
        try {
            setLoadingMore(true);
            const response = await getMemberPayUseList({
                ...searchTypes,
                page: nextPage,
            });

            if (response?.data?.data) {
                appendPageData(response.data.data, searchTypes.size | 5);
            }
        } catch (err) {
            console.error('더보기 에러:', err);
        } finally {
            setLoadingMore(false);
        }
    };


    useEffect(() => {
        handleSearch();
    }, [searchTrigger]);


    return (
        <>
            {loading ? (
                <section className="bg-white no-gap">
                    <div className="inner-box">
                        <p>데이터를 불러오는 중...</p>
                    </div>
                </section>
            ) : !accumulatedRows || accumulatedRows.length === 0 ? (
                <EmptyState message="사용내역이 비어있습니다."/>
            ) : (
            <section className="bg-white no-gap">
                <div className="inner-box">
                    {accumulatedRows.map((item: any, index: number) =>
                    {
                        const adjust = item.adjust;
                        const { date, time } = splitDateTime(item.regDate);
                        const isAdjustment = item.useType === "ADJUSTMENT";
                        const content = isAdjustment ? item.serviceType : adjust ? "급여 조정" : "서비스이용료[" + item.serviceType + "]";

                        const isPlus = isAdjustment ? false : item.useType === "USE_CANCEL" ? true : false;

                        const statusText = isAdjustment ? "차감완료" : item.useType === "USE_CANCEL" ? "결제취소" : "결제완료";

                        return (
                        <div
                            key={item.id}
                            className="payment-wrap"
                            onClick={() => navigate(`/wallet/use-list/${item.transactionCode}`,
                                {state: {useType: item.useType}}
                            )}
                            style={{cursor: "pointer"}}
                        >
                            <div className="payment-info">
                                <div className="info-row">
                                    <div className="time">
                                        {date}
                                        <em className="line">{time}</em>
                                    </div>
                                    <div className={isPlus ? "status cancel" : "status finish"}>{statusText}</div>
                                </div>
                                <div className="info-row">
                                    <div className="cont">{content}</div>
                                    <div className={isPlus ? "amount" : "amount text-red"}>{isPlus ? "+" : "-"}{setComma(item.amount)}원</div>
                                </div>
                                <div className="info-row">
                                    <div className="method">{item.paymentMethod}</div>
                                </div>
                            </div>
                        </div>
                    )
                    })}
                </div>
            </section>
            )}
            <InfiniteScrollSentinel
                showMore={showMoreButton}
                loadingMore={loadingMore}
                loading={loading}
                onLoadMore={handleLoadMore}
            />
        </>
    );
}